import { Alert, AlertTitle, Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

/** Catches render and loader errors so a thrown component never blanks the page. */
export function RootErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();

  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : t('errors.title');

  const detail =
    error instanceof Error
      ? error.message
      : isRouteErrorResponse(error)
        ? String(error.data)
        : t('errors.unexpected');

  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', p: 4 }} role="alert">
      <Stack spacing={2}>
        <Alert severity="error">
          <AlertTitle>{title}</AlertTitle>
          <Typography variant="body2">{detail}</Typography>
        </Alert>
        <Box>
          <Button variant="contained" onClick={() => window.location.assign('/')}>
            {t('common.backToFeed')}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
